import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeBand() {
  return (
    <section className="bg-primary-600">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs font-label mb-4">
              <i className="ri-notification-3-line"></i>
              爆料通讯
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              把今天最值得看的几条，直接发到你邮箱
            </h2>
            <p className="mt-3 text-sm text-primary-100 leading-relaxed font-label">
              订阅后每周收到 1-2 封精选整理，包含热榜变动、重点解读和现场画面，不刷屏、不打扰。
            </p>
          </div>
          <SubscribeForm />
        </div>
      </div>
    </section>
  );
}